export type NauErrorPayload = {
  code?: number;
  message?: string;
};

const ERROR_CODE_MESSAGES: Record<number, string> = {
  1112: "So dien thoai da ton tai",
  1113: "So dien thoai trong",
  1114: "So dien thoai khong hop le",
  1121: "Email da ton tai",
  1122: "Email trong",
  1123: "Email khong hop le",
  30101: "Username khong hop le",
  30103: "Username qua ngan",
  30104: "Username qua dai",
  30105: "Username co ky tu khong hop le",
  30106: "Prefix username khong hop le",
  30107: "Username da ton tai",
  30108: "Mat khau khong hop le",
  30110: "Mat khau qua ngan",
  30112: "Mat khau co khoang trang",
  30201: "Username trong",
  30202: "Password trong",
  30203: "Username hoac Password khong hop le",
};

const DEFAULT_ERROR_MESSAGE = "Dang ky that bai, vui long thu lai sau.";

export const getSignupErrorMessage = (
  status: number,
  payload: NauErrorPayload | null
) => {
  if (status === 409) {
    return "Ban da vuot qua so lan dang ky, vui long thu lai sau.";
  }

  if (status === 503) {
    return "He thong chua duoc cau hinh, vui long quay lai sau.";
  }

  const code = payload?.code;
  if (code && ERROR_CODE_MESSAGES[code]) {
    return ERROR_CODE_MESSAGES[code];
  }

  if (payload?.message) {
    return payload.message;
  }

  return DEFAULT_ERROR_MESSAGE;
};

export const getSigninErrorMessage = (
  status: number,
  payload: NauErrorPayload | null
) => {
  if (status === 503) {
    return "He thong chua duoc cau hinh, vui long quay lai sau.";
  }

  if (status === 409) {
    return "Dang nhap tam thoi khong kha dung, vui long thu lai.";
  }

  const code = payload?.code;
  if (code && ERROR_CODE_MESSAGES[code]) {
    return ERROR_CODE_MESSAGES[code];
  }

  if (payload?.message) {
    return payload.message;
  }

  return "Dang nhap that bai, vui long thu lai.";
};